export const DOWNSIDE_TYPES = [
  { id: 'Please Select', displayValue: 'Please Select', disabled: true },
  { id: 'PUT', displayValue: 'Put' },
  { id: 'KNOCK_IN_PUT', displayValue: 'Knock-in Put' },
  { id: 'NONE', displayValue: 'None' },
];
